<template>
  <div>
    <b-pagination
      v-if="paginacao"
      v-model="currentPage"
      v-on:input="setCurrentPage($event)"
      :total-rows="itemsLength"
      :per-page="paginacao.perPage"
      :limit="3"
      aria-controls="items-list"
      class="custom-pagination mb-0"
    >
    </b-pagination>
  </div>
</template>

<script>
export default {
  props: {
    position: { type: String, default: '' }
  },

  data () {
    return { currentPage: 1 }
  },

  computed: {
    paginacao () {
      this.updatePaginacao()

      return this.$store.getters['borracharia/pagination']
    },
    itemsLength () {
      return this.$store.getters['borracharia/total']
    }
  },

  methods: {
    setCurrentPage (newPage) {
      this.$store.commit('borracharia/setCurrentPage', { page: newPage })

      if (this.position === 'bottom') {
        this.$scrollTo('#osList')
      }
    },
    updatePaginacao () {
      this.currentPage = this.$store.getters['borracharia/pagination'].currentPage
    }
  }
}
</script>
